import React, { useMemo } from "react";
import CommunityPostCard from "../../components/communityPostCard/communityPostCard";
import {
  useAmbassadorHubIds,
  useAmbassadorHubs,
  useMemberHubs,
} from "../../data/communityHub";
import { useAuth } from "../../providers/auth";

export default function SeekerCommunity() {
  const { user } = useAuth();

  const { data: memberHubs = [] }: any = useMemberHubs(user?.email);
  const { data: ambassadorHubIds = [] } = useAmbassadorHubIds(user?.email);
  const { data: ambassadorHubs = [] }: any = useAmbassadorHubs(user?.email);

  const ambassadorIdSet = useMemo(
    () => new Set(ambassadorHubIds),
    [ambassadorHubIds],
  );

  const allHubs = useMemo(() => {
    const byId = new Map<string, any>();
    [...memberHubs, ...ambassadorHubs].forEach((hub: any) => {
      if (hub?.id) byId.set(hub.id, hub);
    });
    return Array.from(byId.values());
  }, [memberHubs, ambassadorHubs]);

  if (allHubs.length === 0) {
    return (
      <div className="pt-24 md:pt-44">
        <div className="text-center mt-10 px-4">
          <h1 className="text-xl md:text-2xl text-instant-teams-blue-Main font-bold">
            No communities found
          </h1>
          <p className="text-gray-500 text-sm md:text-base">
            You are not a member of any communities
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-[160px]">
      <div className="min-h-screen" style={{ background: "rgb(244, 247, 248)" }}>
        <div className="max-w-[1608px] mx-auto px-12 xs:px-3 sm:px-1 md:px-10 lg:px-[60px] py-6 sm:py-8 md:pt-9 md:pb-20">
          <div className="mb-5 md:mb-6">
            <h2 className="font-extrabold text-2xl md:text-[32px] leading-[1.1] text-[rgb(21,65,94)] mb-1.5">
              Your Communities
            </h2>
          </div>

          <div className="grid grid-cols-3 xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {allHubs.map((community: any) => (
              <div key={community.id} className="max-w-[480px]">
                <CommunityPostCard
                  data={community}
                  isAmbassador={ambassadorIdSet.has(community.id)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
